<template lang="html">
    <div class="card">
        <div class="card__head">
            <div class="card__title header-4">{{title}}</div>
            <div class="card__action header-4" @click="$emit('action')">{{action}}</div>
        </div>
        <div class="card__body">
            <slot></slot>
        </div>
        <div class="card__footer"></div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            action: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        background-color: white;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px #0000000F;
        height: auto;
        padding: 25px 30px;
        width: 100%;
        position: relative;

        &--desktop {

            // DISPLAY < 1200px, hidden (MAX-WIDTH)
            @include media-breakpoint-down(xl) {
                display: none;
            }
        }

        &--mobile {

            // DISPLAY > 1200 , hidden (MIN-WIDTH)
            @include media-breakpoint-up(xl) {
                display: none;
            }
        }

        &__head {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        &__title {
            color: $color-card-title;
            font-family: Roboto, sans-serif;
            font-weight: 400;
        }

        &__action {
            color: $color-primary;
            font-weight: 400;
            letter-spacing: 0px;

            &:hover {
                text-decoration: underline;
                cursor: pointer;
            }
        }

        &__body {
            // box-sizing: border-box;
            // display: flex;
            // flex-direction: column;

        }

        &__footer {}
    }
</style>